import { useDispatch, useSelector } from "react-redux";
import { Modal } from "../Modal";
import {
  editPickupModalOpenSelector,
  pickupEditOptionsModalOpenSelector,
} from "../../../reducers/ownApp/selectors";
import {
  editPickupAreasSelector,
  editModalPickupAreasSelector,
  routeInEditSelector,
  pickupModalConfigSelector,
} from "../../../reducers/matrixProfile/selectors";
import {
  applyPickupEdit,
  cancelPickupEdit,
  setModalPickupEditAction,
} from "../../../reducers/matrixProfile/thunkActions";
import { EditPickupContent } from "./EditPickupContent";
import { EditPickupActions } from "./EditPickupActions";

export const EditPickupModal = () => {
  const routeEdit = useSelector(routeInEditSelector);
  const modalOpen = useSelector(editPickupModalOpenSelector);
  const editOptionsModalOpen = useSelector(pickupEditOptionsModalOpenSelector);
  const editModalPickupAreas = useSelector(editModalPickupAreasSelector);
  const editPickupAreas = useSelector(editPickupAreasSelector);
  const pickupModalConfig = useSelector(pickupModalConfigSelector);
  const dispatch = useDispatch();

  const onClose = () => dispatch(cancelPickupEdit());

  const onSave = () => dispatch(applyPickupEdit());

  const onEdit = (key) => dispatch(setModalPickupEditAction({ key }));

  if (!routeEdit || !pickupModalConfig || editOptionsModalOpen) return null;

  return (
    <Modal
      open={modalOpen}
      title={`Pickup: Route ${routeEdit.routeCode}`}
      minWidth={500}
      onClose={onClose}
      content={
        <EditPickupContent
          routeEdit={routeEdit}
          pickupModalConfig={pickupModalConfig}
          onEdit={onEdit}
        />
      }
      actions={
        <EditPickupActions
          disabled={editModalPickupAreas === editPickupAreas}
          onCancel={onClose}
          onSave={onSave}
        />
      }
    />
  );
};
